
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import noDisclosure from '@/components/nodisclosure';
import TaxStatus from "@/common/customs/TaxStatus";

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['showSoldPrice'],
    data: function() {
        return {};
    },
    components: { noDisclosure, TaxStatus },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        trend() {
            if (this.info.price) {
                return (
                    (
                        (Math.abs(this.info.soldPrice - this.info.price) /
                            this.info.price) *
                        100
                    ).toFixed(1) + '%'
                );
            } else {
                return '0.0%';
            }
        },
        houseShowSoldPrice() {
            return this.showSoldPrice && this.info.listingStatus == 'Sold'
        },
        showListingPrice() {
            return (
                this.house.showListingPrice && this.info.listingStatus == 'Sold'
            );
        },
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }

    }
};